import Arrow from "./arrow"

export default class ArrowLeftForm extends Arrow {
  protected points(width: number, height: number) {
    const aw = width - height / 2
    const x = -width / 2
    const y = height / 2
    const points = []

    if (height >= width * 2) {
      points.push({ x: x + width, y: y - height })
      points.push({ x, y: y - height * 0.5 })
      points.push({ x: x + width, y })
    } else {
      points.push({ x: x + width, y: y - height * 0.2 })
      points.push({ x: x + width, y: y - height * 0.8 })
      points.push({ x: x + width - aw, y: y - height * 0.8 })
      points.push({ x: x + width - aw, y: y - height })
      points.push({ x, y: y - height * 0.5 })
      points.push({ x: x + width - aw, y })
      points.push({ x: x + width - aw, y: y - height * 0.2 })
      points.push({ x: x + width, y: y - height * 0.2 })
    }

    return points
  }
}
